// Add two comment lines, to match the one from v2/new-original.js and have same....
// breakpoint column positions.......................
window.removedOriginal = function removedOriginal() {
  console.log("Removed original");
}
